import { memo, useMemo } from 'react';

import loadable from '../../../../utils/loadable';

import { generateIdentifier } from '../../../../helpers/companyHelpers';
import { queryItemWatchlistParser } from '../../../../helpers/watchlistHelperFunctions';
import getInsiderTransactionTickers from '../../../../helpers/getInsiderTransactionTickers';

import InsiderTransactionsTabOptionsContext from '../../../SEO_pages/Topic/InsiderTransactionsTab/InsiderTransactionsTabOptionsContext';

import Styles from './styles.module.scss';

const InsiderTransactionsTab = loadable(() => import('../../../SEO_pages/Topic/InsiderTransactionsTab'));
const InsiderTransactionsTable = loadable(() => import('../../../SEO_pages/InsiderTransactionsTable'));

export const InsiderTransactions = ({ topics, multipleTopics }) => {
  const identifier = topics.map((topic) => {
    const usTickers = getInsiderTransactionTickers(topic);

    return generateIdentifier({
      ticker: usTickers[0].full_name,
    });
  }).join(',');

  const companiesData = useMemo(() => (
    topics.map((topic) => {
      const tickers = getInsiderTransactionTickers(topic)
        .map((ticker) => ticker.full_name);

      return {
        name: queryItemWatchlistParser(topic.query)?.name,
        tickers,
      };
    })
  ), [topics]);

  return (
    <div className={Styles['insider-transactions']}>
      {!multipleTopics && topics.length === 1 ? (
        <InsiderTransactionsTab slug={topics[0]} isWatchlistPage />
      ) : (
        <InsiderTransactionsTabOptionsContext.Provider value={{ isWatchlistPage: true }}>
          <InsiderTransactionsTable
            multipleCompanies
            identifier={identifier}
            companiesData={companiesData}
          />
        </InsiderTransactionsTabOptionsContext.Provider>
      )}
    </div>
  );
};

export default memo(InsiderTransactions);
